console.log('with fileuploader')

import { fileUpload } from '../components/fileuploader.js'

document.addEventListener("turbolinks:load", function(event) {
  document.querySelectorAll('.directupload').forEach(function (fileInputContainer) {
    fileUpload(fileInputContainer)
  })
})
